// ============================================
// ANNOUNCEMENT BAR STICKY — CONTROL MANUAL
// Cambiar a false para desactivar
// ============================================
const ANNOUNCEMENT_STICKY_ENABLED = true;
// ============================================

document.addEventListener('DOMContentLoaded', function () {

  if (!ANNOUNCEMENT_STICKY_ENABLED) {
    console.log('[AnnouncementSticky] Funcionalidad DESACTIVADA.');
    return; // Sale inmediatamente sin ejecutar nada
  }

  const announcementBar = document.querySelector('.announcement-bar-section');
  const stickyHeader = document.querySelector('sticky-header');

  if (!announcementBar || !stickyHeader) return;

  announcementBar.style.transition = 'transform 0.3s ease';
  announcementBar.style.position = 'sticky';
  announcementBar.style.top = '0';
  announcementBar.style.zIndex = '101';

  const observer = new MutationObserver(function () {
    const isScrolledUp = stickyHeader.classList.contains('scrolled-up');
    const isScrolledPast = stickyHeader.classList.contains('scrolled-past-header');

    if (isScrolledUp || !isScrolledPast) {
      announcementBar.style.transform = 'translateY(0)';
    } else {
      announcementBar.style.transform = 'translateY(-100%)';
    }
  });

  observer.observe(stickyHeader, {
    attributes: true,
    attributeFilter: ['class']
  });

  console.log('[AnnouncementSticky] Funcionalidad ACTIVA.');
});
